import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取促活短信列表
export const getSmsList = params => {
    return get("/admin/smsMarket/list", params);
};
// 行为触发开关
export const smsSwitch = params => {
    return post("/admin/smsMarket/turnTriggerButton", params);
};



// WEBPACK FOOTER //
// ./src/api/sms.js